import HttpRequest from '@/util/HttpRequest'

export default {

}
